import LazyLoad from "vanilla-lazyload";
const myLazyLoad = new LazyLoad({
 /* other options here */
 elements_selector: "img" // ADD THIS OPTION
});
